const Logo =  '../../../assets/images/logo.png';
const HeaderBackground = '../../../assets/images/header-wrapper-bg.jpg';
const HelpDummyImg = '../../../assets/images/help_dummy_img.png';
const ChevronLeft = '../../../assets/images/chevron_left_solid_ruby.svg';
const ChevronRight = '../../../assets/images/chevron_right_solid_ruby.svg';
const ResultSuccess = '../../../assets/images/basarili_sonuc_icon.png';
const ResultFail = '../../../assets/images/basarisiz_sonuc_icon.png';
const StartApplication = '../../../assets/images/basvuru_basla_icon.png';
const AtmMapIcon = '../../../assets/images/atm_map_icon.png';
const BranchMapIcon = '../../../assets/images/sube_map_icon.png';
const BranchMapIconRuby = '../../../assets/images/sube_map_icon_ruby.png';
const CheckInfoBankCodeImg = '../../../assets/images/CekInfo/BankaKodu.jpg';
const CheckInfoCheckBranchCodeImg = '../../../assets/images/CekInfo/BankaSubeKodu.jpg';
const CheckInfoCheckNoImg = '../../../assets/images/CekInfo/CekNo.jpg';
const CheckInfoAccountNoImg = '../../../assets/images/CekInfo/HesapNo.jpg';
const CheckInfoDrawerBankInfoImg = '../../../assets/images/CekInfo/KesideciBankaBilgileri.jpg';




export class ImageConstants {
    public static Logo = Logo;
    public static HeaderBackground = HeaderBackground;
    public static HelpDummyImg = HelpDummyImg;
    public static ChevronLeft = ChevronLeft;
    public static ChevronRight = ChevronRight;
    public static ResultSuccess = ResultSuccess;
    public static ResultFail = ResultFail;
    public static StartApplication = StartApplication;
    public static AtmMapIcon = AtmMapIcon;
    public static BranchMapIcon = BranchMapIcon;
    public static BranchMapIconRuby = BranchMapIconRuby;
    public static CheckInfoBankCodeImg = CheckInfoBankCodeImg;
    public static CheckInfoCheckBranchCodeImg = CheckInfoCheckBranchCodeImg;
    public static CheckInfoCheckNoImg = CheckInfoCheckNoImg;
    public static CheckInfoAccountNoImg = CheckInfoAccountNoImg;
    public static CheckInfoDrawerBankInfoImg = CheckInfoDrawerBankInfoImg;

}
